const useColumns = () => {
  const columns = [
    { Header: "ลำดับ", accessor: "id", showInFilter: false },
    { Header: "วัน เดือน ปี", accessor: "date", showInFilter: false },
    { Header: "รหัสรายการ", accessor: "order_code", showInFilter: false },
    { Header: "สถานะ", accessor: "status", showInFilter: false },
    { Header: "ยอดเงิน", accessor: "balance", showInFilter: false },
  ];

  return columns;
};

export default useColumns;
